import { Mail, Facebook, Instagram, Linkedin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border/50 bg-card/30 backdrop-blur-xl relative">
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo e Descrição */}
          <div>
            <img src="/logo.png" alt="Coddar Logo" className="h-10 w-auto mb-4" />
            <p className="text-sm text-muted-foreground mb-4">
              Transformando ideias em soluções tecnológicas inovadoras desde 2019.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="h-9 w-9 rounded-full bg-primary/10 hover:bg-primary/20 flex items-center justify-center transition-colors">
                <Facebook className="h-4 w-4 text-primary" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="h-9 w-9 rounded-full bg-primary/10 hover:bg-primary/20 flex items-center justify-center transition-colors">
                <Instagram className="h-4 w-4 text-primary" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="h-9 w-9 rounded-full bg-primary/10 hover:bg-primary/20 flex items-center justify-center transition-colors">
                <Linkedin className="h-4 w-4 text-primary" />
              </a>
              <a href="https://wa.me/5513997049254" target="_blank" rel="noopener noreferrer" className="h-9 w-9 rounded-full bg-primary/10 hover:bg-primary/20 flex items-center justify-center transition-colors">
                <MessageCircle className="h-4 w-4 text-primary" />
              </a>
            </div>
          </div>

          {/* Serviços */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/desenvolvimento-software" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Desenvolvimento de Software
                </Link>
              </li>
              <li>
                <Link to="/automacao-processos" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Automação de Processos
                </Link>
              </li>
              <li>
                <Link to="/seguranca-digital" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Segurança Digital
                </Link>
              </li>
              <li>
                <Link to="/consultoria-ti" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Consultoria em TI
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Úteis */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Links Úteis</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contato
                </Link>
              </li>
              <li>
                <a href="https://folio.app.br/area-cliente" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Área do Cliente
                </a>
              </li>
              <li>
                <Link to="/politica-privacidade" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Newsletter</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Receba novidades e dicas sobre tecnologia
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="flex-1 px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <Button size="sm" className="gap-2">
                <Mail className="h-4 w-4" />
              </Button>
            </div>
            <a
              href="https://wa.me/5513997049254?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20os%20serviços"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-md transition-colors text-sm font-medium"
            >
              <MessageCircle className="h-4 w-4" />
              Fale no WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2019-2024 Coddar. Todos os direitos reservados.
          </p>
          <div className="flex gap-4">
            <Link to="/termos-uso" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Termos de Uso
            </Link>
            <Link to="/politica-privacidade" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
